import {StaticLandingTypeVo} from '../../common/shared/api/karina/vo/enums/StaticLandingTypeVo.enum';
import {StaticLandingType} from '../generated/types';

export function createStaticLandingType(
  staticLandingTypeVo?: StaticLandingTypeVo
): StaticLandingType | undefined {
  if (!staticLandingTypeVo) {
    return;
  }
  return map[staticLandingTypeVo];
}

const map: {
  [key in StaticLandingTypeVo]: StaticLandingType;
} = {
  [StaticLandingTypeVo.TodayNew]: StaticLandingType.TodayNew,
  [StaticLandingTypeVo.TodayUp]: StaticLandingType.TodayUp,
  [StaticLandingTypeVo.TodayUpInven]: StaticLandingType.TodayUpInven,
  [StaticLandingTypeVo.Original]: StaticLandingType.Original,
  [StaticLandingTypeVo.Event]: StaticLandingType.Event,
  [StaticLandingTypeVo.Ranking]: StaticLandingType.Ranking,
  [StaticLandingTypeVo.RankingTheme]: StaticLandingType.RankingTheme,
  [StaticLandingTypeVo.DayOfWeek]: StaticLandingType.DayOfWeek,
  [StaticLandingTypeVo.FreeSeries]: StaticLandingType.FreeSeries,
  [StaticLandingTypeVo.Genre]: StaticLandingType.Genre,
};
